export const DIGITAL_OCEAN_PATH =
  "https://narinfile.sgp1.digitaloceanspaces.com";

export const IMAGE_NOT_FOUND = "https://narinonline.com/not-found-product.png";

export const IMAGE_EXTENSION = [
  ".jpg",
  ".jpeg",
  ".png",
  ".gif",
  ".bmp",
  ".webp",
  ".svg",
  ".tiff",
  ".ico",
];

export enum E_USER_TIER {
  GROCERY = 1,
  NURSE = 2,
  DOCTOR = 3,
  PHARMACY = 4,
  GENERAL = 5,
}
export enum E_ORDER_STATUS {
  ALL = "ALL",
  PENDING = "PENDING", //รอเตรียมสินค้า
  PACKING = "PACKING", // เริ่มแพ็ค
  CONFIRMED = "CONFIRMED",
  COMPLETED = "COMPLETED",
  PREPARING = "PREPARING", // เริ่มจัด
  CHECKING = "CHECKING", // เริ่มเช็ค
  KEYING = "KEYING", // เริ่มคีย์
  CANCELLED = "CANCELLED",
}
export enum E_PAYMENT_STATUS {
  NOT_PAID = "NOT_PAID",
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
  REJECTED = "REJECTED",
}
export const OrderStatusLabels: Record<E_ORDER_STATUS, string> = {
  [E_ORDER_STATUS.ALL]: "ทั้งหมด",
  [E_ORDER_STATUS.PENDING]: "รอเตรียมสินค้า",
  [E_ORDER_STATUS.PREPARING]: "รอเตรียมสินค้า",
  [E_ORDER_STATUS.CHECKING]: "รอเตรียมสินค้า",
  [E_ORDER_STATUS.PACKING]: "รอเตรียมสินค้า",
  [E_ORDER_STATUS.CONFIRMED]: "เตรียมสินค้าแล้ว",
  [E_ORDER_STATUS.COMPLETED]: "เสร็จสมบูรณ์",
  [E_ORDER_STATUS.CANCELLED]: "ยกเลิกแล้ว",
  [E_ORDER_STATUS.KEYING]: "รอเตรียมสินค้า",
};

export const PaymentStatusLabels: Record<E_PAYMENT_STATUS, string> = {
  [E_PAYMENT_STATUS.NOT_PAID]: "ยังไม่ได้ชำระเงิน",
  [E_PAYMENT_STATUS.PENDING]: "รอการตรวจสอบ",
  [E_PAYMENT_STATUS.SUCCESS]: "ชำระเงินแล้ว",
  [E_PAYMENT_STATUS.REJECTED]: "ชำระเงินไม่สำเร็จ",
};

export const PaymentStatusColor: Record<E_PAYMENT_STATUS, string> = {
  [E_PAYMENT_STATUS.NOT_PAID]: "bg-[#D2D2D2CC]",
  [E_PAYMENT_STATUS.PENDING]: "bg-[#D2D2D2CC]",
  [E_PAYMENT_STATUS.SUCCESS]: "bg-[#CCF1DD]",
  [E_PAYMENT_STATUS.REJECTED]: "bg-[#f7ce7e] text-[#915945]",
};

export const PaymentStatusTagColor: Record<E_PAYMENT_STATUS, string> = {
  [E_PAYMENT_STATUS.NOT_PAID]: "cyan",
  [E_PAYMENT_STATUS.PENDING]: "orange",
  [E_PAYMENT_STATUS.SUCCESS]: "green",
  [E_PAYMENT_STATUS.REJECTED]: "red",
};

export const OrderStatusTagColor: Record<E_ORDER_STATUS, string> = {
  [E_ORDER_STATUS.ALL]: "",
  [E_ORDER_STATUS.PENDING]: "gold",
  [E_ORDER_STATUS.PREPARING]: "gold",
  [E_ORDER_STATUS.CHECKING]: "gold",
  [E_ORDER_STATUS.PACKING]: "gold",
  [E_ORDER_STATUS.KEYING]: "gold",
  [E_ORDER_STATUS.CONFIRMED]: "cyan",
  [E_ORDER_STATUS.COMPLETED]: "green",
  [E_ORDER_STATUS.CANCELLED]: "red",
};

// Desktop layout is a fixed-width canvas (see Desktop/Container.tsx).
// DESKTOP_DESIGN_WIDTH is that canvas width; the layout auto-scales to fit
// viewports narrower than this (see useFitScale) so there is no horizontal scroll.
export const DESKTOP_DESIGN_WIDTH = 1440;

// Below this width we render the mobile layout. Kept below common laptop
// usable widths (e.g. 1272px = 1280px screen minus scrollbar / display scaling)
// so those users get the desktop layout instead of the mobile one.
export const IS_BREAKPOINT_DESKTOP = "(min-width: 1024px)";
